import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Done, DoneAll, InsertDriveFile } from '@mui/icons-material';
import { Message } from '../../types/chat.types';
import { UserAvatar } from '../common/UserAvatar.tsx';

interface MessageItemProps {
  message: Message;
  isOwn: boolean;
  showAvatar: boolean;
}

export const MessageItem: React.FC<MessageItemProps> = ({ message, isOwn, showAvatar }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: isOwn ? 'flex-end' : 'flex-start', 
      mb: 0.5,
      mt: showAvatar ? 1 : 0
    }}>
      {!isOwn && (
        <Box sx={{ width: 40, mr: 1, display: 'flex', alignItems: 'flex-end' }}>
          {showAvatar ? (
             <UserAvatar name={message.senderName} path={message.senderAvatar} sx={{ width: 32, height: 32 }} />
          ) : (
             <Box sx={{ width: 32 }} />
          )}
        </Box>
      )}

      <Paper 
        elevation={0} 
        sx={{ 
          p: '8px 12px', 
          maxWidth: '70%', 
          backgroundColor: isOwn ? 'primary.main' : '#f0f2f5',
          color: isOwn ? 'primary.contrastText' : 'text.primary',
          borderRadius: isOwn 
            ? '18px 18px 4px 18px' 
            : '18px 18px 18px 4px',
          position: 'relative',
          wordBreak: 'break-word'
        }}
      >
        {message.message && (
          <Typography variant="body1" sx={{ fontSize: '0.95rem', lineHeight: 1.4 }}>
            {message.message}
          </Typography>
        )}

        {message.attachment && (
          <Box
            component="a"
            href={message.attachment.url}
            download={message.attachment.fileName}
            target="_blank"
            rel="noopener"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.75,
              mt: message.message ? 0.75 : 0,
              p: '6px 10px',
              borderRadius: '12px',
              backgroundColor: 'rgba(0, 0, 0, 0.06)',
              color: 'inherit',
              textDecoration: 'none',
              cursor: 'pointer',
            }}
          >
            <InsertDriveFile sx={{ fontSize: 20 }} />
            <Typography variant="body2" sx={{ fontSize: '0.85rem', wordBreak: 'break-all' }}>
              {message.attachment.fileName}
            </Typography>
          </Box>
        )}

        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'flex-end', 
          gap: 0.5, 
          mt: 0.5,
          opacity: isOwn ? 0.8 : 0.6 
        }}>
          <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
            {new Date(message.sentAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </Typography>
          {isOwn && (
            message.isRead ? (
              <DoneAll sx={{ fontSize: 14 }} />
            ) : (
              <Done sx={{ fontSize: 14 }} />
            )
          )}
        </Box>
      </Paper>
    </Box>
  );
};
